import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=4e85d5bb"
import script from "./sales.vue?vue&type=script&lang=ts"
export * from "./sales.vue?vue&type=script&lang=ts"
import style0 from "./sales.vue?vue&type=style&index=0&id=4e85d5bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports